import React from "react";
import {FormattedMessage} from "react-intl";
import {Card} from "peggirkit";
import {PlacedOrderOverview} from "@/data/entities/order";
import {ShoppingBagIcon, TruckIcon} from "@heroicons/react/20/solid";
import RequestedTime from "@widgets/pos/orders/details/order/overview/header/RequestedTime";

type Props = {
    order: PlacedOrderOverview,
};

const OrderFulfillment = ({order}: Props) => {
    const FulfillmentIcon = order.delivery ? TruckIcon : ShoppingBagIcon;

    return (
        <Card containerClassname={"text-right !w-fit"}>
            <div className={"flex flex-row flex-nowrap items-start justify-start gap-6"}>
                <div
                    className={"bg-blue-100 text-blue-800 dark:bg-blue-400/10 dark:text-blue-400 p-2 rounded"}
                >
                    <FulfillmentIcon className={"size-10"}/>
                </div>

                <div>
                    <p className={"whitespace-nowrap text-gray-600 dark:text-slate-300 font-medium"}>
                        <FormattedMessage id={order.delivery ? "delivery-on" : "takeaway-on"}/>
                    </p>
                    <p className={"font-bold text-2xl"}>
                        <RequestedTime order={order}/>
                    </p>
                </div>
            </div>
        </Card>
    );
};

export default OrderFulfillment;